// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sideNav-section {
  width: 70px;
  height: 100vh;
  display: block;
  margin-top: 1px;
  box-shadow: 0px 12px 14px 2px rgba(0, 0, 0, 0.031372549);
}

.arrowclick {
  position: absolute;
  left: 13.7rem;
  z-index: 99999;
  height: 30px;
  background: var(--color-white);
  width: 30px;
  top: 63px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  border: solid 1px var(--color-black);
  border-radius: 50%;
  cursor: pointer;
}

.nav-text {
  width: 2rem;
  height: 2rem;
}

.navbar-toggle {
  background-color: #00243d;
  width: 100%;
  display: flex;
  justify-content: start;
  align-items: center;
  height: 65px;
}

.nav-menu {
  left: -10.5rem;
  padding-left: 0px;
  background-color: var(--color-maersk-darkblue) !important;
  width: 250px;
  height: 100vh;
  display: flex;
  justify-content: center;
  position: fixed;
  top: 50px;
  transition: 850ms;
}
.nav-menu span {
  margin-left: 16px;
}
.nav-menu.active {
  left: 0;
  transition: 350ms;
}
.nav-menu.active .nav-menu-items .nav-text.active {
  border-left: 4px solid #42b0d5;
}
.nav-menu.active li.active {
  background: rgba(255, 255, 255, 0.15);
}

.icon-view {
  margin-left: 10.5em !important;
}

.nav-menu-items {
  padding-left: 0px;
  width: 100%;
}
.nav-menu-items .nav-text {
  margin-bottom: 30px;
  margin-top: 15px;
  padding: 20px 0px;
  width: 2rem;
  height: 2rem;
  display: flex;
  justify-content: start;
  align-items: center;
  list-style: none;
}
.nav-menu-items .nav-text.active {
  width: 100%;
}
.nav-menu-items .nav-text.active a span {
  color: #42b0d5;
}
.nav-menu-items .nav-text a {
  padding-left: 0px;
  white-space: nowrap;
  text-decoration: none;
  display: flex;
}
.nav-menu-items .nav-text a.bottom-title {
  display: block;
  white-space: nowrap;
  text-align: center;
}
.nav-menu-items .nav-text a.bottom-title span.tittle-hide {
  margin-left: 10.5rem;
  font-size: 12px;
  white-space: break-spaces;
  width: 80px;
  text-align: center;
  padding: 1px;
  line-height: 14px;
}
.nav-menu-items .nav-text a span {
  color: var(--color-white);
  display: block;
}
.nav-menu-items .nav-text.feedback-button {
  position: absolute;
  bottom: 2.2rem;
}
.nav-menu-items .nav-text.feedback-button-active {
  width: 100%;
  position: absolute;
  bottom: 1.8rem;
  border-top: 0.5px solid var(--color-white);
  background: #42b0d5;
}
.nav-menu-items .nav-text .feedback-name {
  border: none;
  background: none;
}
.nav-menu-items .nav-text .feedback-name div {
  padding-left: 0px;
  white-space: nowrap;
  text-decoration: none;
  display: flex;
}
.nav-menu-items .nav-text .feedback-name div span {
  color: var(--color-white);
  display: block;
}
.nav-menu-items .nav-text .feedback-name div.bottom-title {
  display: block;
  white-space: nowrap;
  text-align: center;
  margin-top: 5px;
  border-top: 0.5px solid #ffffff;
  padding-top: 5px;
  padding-bottom: 5px;
  background: #42b0d5;
  margin-left: 2px;
}
.nav-menu-items .nav-text .feedback-name div.bottom-title span.title-hide {
  margin-left: 10.5rem;
  font-size: 12px;
  white-space: break-spaces;
  width: 80px;
  text-align: center;
  padding: 1px;
}`, "",{"version":3,"sources":["webpack://./src/Layouts/SideNav/SideNav.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,wDAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,YAAA;EACA,8BAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,kBAAA;EACA,eAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,yBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;AACF;;AAEA;EACE,cAAA;EACA,iBAAA;EACA,yDAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,SAAA;EACA,iBAAA;AACF;AACE;EACE,iBAAA;AACJ;AAEE;EACE,OAAA;EACA,iBAAA;AAAJ;AAEI;EACE,8BAAA;AAAN;AAGI;EACE,qCAAA;AADN;;AAMA;EACE,8BAAA;AAHF;;AAMA;EACE,iBAAA;EACA,WAAA;AAHF;AAKE;EACE,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AAHJ;AAKI;EACE,WAAA;AAHN;AAMQ;EACE,cAAA;AAJV;AASI;EACE,iBAAA;EACA,mBAAA;EACA,qBAAA;EACA,aAAA;AAPN;AASM;EACE,cAAA;EACA,mBAAA;EACA,kBAAA;AAPR;AASQ;EACE,oBAAA;EACA,eAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AAPV;AAWM;EACE,yBAAA;EACA,cAAA;AATR;AAaI;EACE,kBAAA;EACA,cAAA;AAXN;AAcI;EACE,WAAA;EACA,kBAAA;EACA,cAAA;EACA,0CAAA;EACA,mBAAA;AAZN;AAeI;EACE,YAAA;EACA,gBAAA;AAbN;AAcM;EACE,iBAAA;EACA,mBAAA;EACA,qBAAA;EACA,aAAA;AAZR;AAcQ;EACE,yBAAA;EACA,cAAA;AAZV;AAeQ;EACE,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,+BAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AAbV;AAcU;EACE,oBAAA;EACA,eAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;AAZZ","sourcesContent":[".sideNav-section {\n  width: 70px;\n  height: 100vh;\n  display: block;\n  margin-top: 1px;\n  box-shadow: 0px 12px 14px 2px #00000008;\n}\n\n.arrowclick {\n  position: absolute;\n  left: 13.7rem;\n  z-index: 99999;\n  height: 30px;\n  background: var(--color-white);\n  width: 30px;\n  top: 63px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: solid 1px var(--color-black);\n  border-radius: 50%;\n  cursor: pointer;\n}\n\n.nav-text {\n  width: 2rem;\n  height: 2rem;\n}\n\n.navbar-toggle {\n  background-color: #00243d;\n  width: 100%;\n  display: flex;\n  justify-content: start;\n  align-items: center;\n  height: 65px;\n}\n\n.nav-menu {\n  left: -10.5rem;\n  padding-left: 0px;\n  background-color: var(--color-maersk-darkblue) !important;\n  width: 250px;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  position: fixed;\n  top: 50px;\n  transition: 850ms;\n\n  span {\n    margin-left: 16px;\n  }\n\n  &.active {\n    left: 0;\n    transition: 350ms;\n\n    .nav-menu-items .nav-text.active {\n      border-left: 4px solid #42b0d5;\n    }\n\n    li.active {\n      background: rgba(255, 255, 255, 0.15);\n    }\n  }\n}\n\n.icon-view {\n  margin-left: 10.5em !important;\n}\n\n.nav-menu-items {\n  padding-left: 0px;\n  width: 100%;\n\n  .nav-text {\n    margin-bottom: 30px;\n    margin-top: 15px;\n    padding: 20px 0px;\n    width: 2rem;\n    height: 2rem;\n    display: flex;\n    justify-content: start;\n    align-items: center;\n    list-style: none;\n\n    &.active {\n      width: 100%;\n\n      a {\n        span {\n          color: #42b0d5;\n        }\n      }\n    }\n\n    a {\n      padding-left: 0px;\n      white-space: nowrap;\n      text-decoration: none;\n      display: flex;\n\n      &.bottom-title {\n        display: block;\n        white-space: nowrap;\n        text-align: center;\n\n        span.tittle-hide {\n          margin-left: 10.5rem;\n          font-size: 12px;\n          white-space: break-spaces;\n          width: 80px;\n          text-align: center;\n          padding: 1px;\n          line-height: 14px;\n        }\n      }\n\n      span {\n        color: var(--color-white);\n        display: block;\n      }\n    }\n\n    &.feedback-button {\n      position: absolute;\n      bottom: 2.2rem;\n    }\n\n    &.feedback-button-active {\n      width: 100%;\n      position: absolute;\n      bottom: 1.8rem;\n      border-top: 0.5px solid var(--color-white);\n      background: #42b0d5;\n    }\n\n    .feedback-name {\n      border: none;\n      background: none;\n      div {\n        padding-left: 0px;\n        white-space: nowrap;\n        text-decoration: none;\n        display: flex;\n\n        span {\n          color: var(--color-white);\n          display: block;\n        }\n\n        &.bottom-title {\n          display: block;\n          white-space: nowrap;\n          text-align: center;\n          margin-top: 5px;\n          border-top: 0.5px solid #ffffff;\n          padding-top: 5px;\n          padding-bottom: 5px;\n          background: #42b0d5;\n          margin-left: 2px;\n          span.title-hide {\n            margin-left: 10.5rem;\n            font-size: 12px;\n            white-space: break-spaces;\n            width: 80px;\n            text-align: center;\n            padding: 1px;\n          }\n        }\n\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
